import { render, staticRenderFns } from "./RequiredDocuments.vue?vue&type=template&id=ec9fe2c0"
import script from "./RequiredDocuments.vue?vue&type=script&lang=js"
export * from "./RequiredDocuments.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/pages/user-site/required-documents.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports